import { Link } from "react-router-dom";
import "./notification.css";
import Sidebare from "../Sidbare/Sidebare";
import { NotificationMagasinType } from "../../../Modeles/NotificationModel";
import { useEffect, useState } from "react";
import GetNotificationAdmin from "../../../Services/Admin/GetNotificationAdmin";
import Strip from "../../../components/Strip";
import SideBarMobile from "../Sidbare/SideBarMobile";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
import axios from "axios";

export interface NotificationType {
  Notifications: NotificationMagasinType[];
  messageErrosNotif: string;
}

export default function NotificationAdmin() {
  const [stateNotification, setStateNotification] = useState<NotificationType>({
    Notifications: [] as NotificationMagasinType[],
    messageErrosNotif: "Aucune Notification",
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [Popup, setPopup] = useState(false);
  const [selectedNotif, setSelectedNotif] = useState<any>(null);

  useEffect(() => {
    GetNotificationAdmin()
      .GetNotification()
      .then((res) => {
        setStateNotification({ ...stateNotification, Notifications: res.data });
        setLoading(false);
      })
      .catch((error) => {
        setStateNotification({
          ...stateNotification,
          messageErrosNotif: "Aucune Notification",
        });
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const MarkAsRead = async (IdNotif: any) => {
    try {
      const AdminId = localStorage.getItem("AdminId") || 1;
      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasins/${AdminId}/notification/${IdNotif}`
      );
      GetNotificationAdmin().ClearCache();
      setPopup(true);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la notification", error);
    }
  };

  const handleClickNotif = (notif: any) => {
    setSelectedNotif(notif);
    setPopup(true);
    // Optimistically mark as read in local state immediately
    if (notif.IsRead !== 1) {
      setStateNotification(prev => ({
        ...prev,
        Notifications: prev.Notifications.map((n: any) =>
          n.id === notif.id ? { ...n, IsRead: 1 } : n
        ),
      }));
    }
    MarkAsRead(notif.id);
  };

  const { Notifications, messageErrosNotif } = stateNotification;
  const unreadCount = Notifications.filter((n: any) => n.IsRead === 0).length;

  if (screenWidth <= 450) {
    return (
      <>
               <NewSideBarAdmin/>

        <div className="mobile-notifications-nadm">
          <div className="mobile-header-nadm">
            <h2 className="mobile-title-nadm">Notifications</h2>
            {unreadCount > 0 && (
              <div className="mobile-badge-nadm">{unreadCount}</div>
            )}
          </div>

          {loading ? (
            <div className="loader-container-nadm">
              <div className="spinner-nadm"></div>
              <span className="loader-text-nadm">Chargement...</span>
            </div>
          ) : Notifications.length > 0 ? (
            <div className="mobile-list-nadm">
              {Notifications.map((notif, index) => (
                <div
                  key={notif.Date}
                  className={`mobile-card-nadm ${
                    notif.IsRead === 1 ? "read-nadm" : "unread-nadm"
                  }`}
                  onClick={() => handleClickNotif(notif)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {notif.IsRead === 0 && (
                    <div className="mobile-indicator-nadm"></div>
                  )}

                  <div className="mobile-icon-nadm">
                    <i className="bi bi-bell-fill"></i>
                  </div>

                  <div className="mobile-content-nadm">
                    <span className="mobile-date-nadm">{notif.Date}</span>
                    <h3 className="mobile-notif-title-nadm">{notif.Title}</h3>
                    <p className="mobile-message-nadm">{notif.Content}</p>
                    <span
                      className={`mobile-status-nadm ${
                        notif.IsRead === 1 ? "read-status-nadm" : "unread-status-nadm"
                      }`}
                    >
                      {notif.IsRead === 1 ? "Déjà lue" : "Nouvelle"}
                    </span>
                  </div>

                  <i className="bi bi-chevron-right mobile-arrow-nadm"></i>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state-nadm mobile-empty-nadm">
              <div className="empty-icon-nadm">
                <i className="bi bi-bell-slash"></i>
              </div>
              <h3 className="empty-title-nadm">Aucune notification</h3>
              <p className="empty-text-nadm">
                Nous vous préviendrons dès qu'il y aura du nouveau.
              </p>
            </div>
          )}
        </div>
      </>
    );
  }

  return (
    <>
      <NewSideBarAdmin />

      <div className="notifications-admin-page-nadm">
        {/* Header */}
        <div className="admin-header-nadm">
          <div className="admin-header-content-nadm">
            <div className="admin-header-left-nadm">
              <div className="admin-icon-wrapper-nadm">
                <i className="bi bi-bell-fill"></i>
              </div>
              <div className="admin-header-text-nadm">
                <h1 className="admin-title-nadm">Centre de Notifications</h1>
                <p className="admin-subtitle-nadm">
                  Gérez toutes vos notifications en un seul endroit
                </p>
              </div>
            </div>
            {unreadCount > 0 && (
              <div className="admin-unread-badge-nadm">
                <span>
                  {unreadCount} non lue{unreadCount > 1 ? "s" : ""}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Notifications Container */}
        <div className="admin-notifications-container-nadm">
          {loading ? (
            <div className="loader-container-nadm">
              <div className="spinner-nadm"></div>
              <span className="loader-text-nadm">
                Chargement des notifications...
              </span>
            </div>
          ) : Notifications.length > 0 ? (
            <div className="admin-notifications-grid-nadm">
              {Notifications.map((notif, index) => (
                <div
                  key={notif.Date}
                  className={`admin-notification-card-nadm ${
                    notif.IsRead === 1 ? "read-nadm" : "unread-nadm"
                  }`}
                  onClick={() => handleClickNotif(notif)}
                  style={{ animationDelay: `${index * 0.08}s` }}
                >
                  {/* Unread Indicator */}
                  {notif.IsRead === 0 && (
                    <div className="admin-unread-indicator-nadm"></div>
                  )}

                  {/* Icon */}
                  <div
                    className={`admin-notification-icon-nadm ${
                      notif.IsRead === 1
                        ? "read-icon-nadm"
                        : "unread-icon-nadm"
                    }`}
                  >
                    <i className="bi bi-bell-fill"></i>
                  </div>

                  {/* Content */}
                  <div className="admin-notification-content-nadm">
                    <div className="admin-notification-header-nadm">
                      <h3 className="admin-notification-title-nadm">
                        {notif.Title}
                      </h3>
                      <span className="admin-notification-date-nadm">
                        {notif.Date}
                      </span>
                    </div>

                    <p className="admin-notification-message-nadm">
                      {notif.Content}
                    </p>

                    {/* Footer */}
                    <div className="admin-notification-footer-nadm">
                      <span
                        className={`admin-status-badge-nadm ${
                          notif.IsRead === 1
                            ? "read-status-nadm"
                            : "unread-status-nadm"
                        }`}
                      >
                        {notif.IsRead === 1 ? (
                          <>
                            <i className="bi bi-check-circle-fill"></i>
                            <span>Déjà lue</span>
                          </>
                        ) : (
                          <>
                            <i className="bi bi-circle-fill"></i>
                            <span>Nouvelle</span>
                          </>
                        )}
                      </span>

                      <div className="admin-arrow-icon-nadm">
                        <i className="bi bi-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state-nadm">
              <div className="empty-icon-wrapper-nadm">
                <i className="bi bi-bell-slash"></i>
              </div>
              <h2 className="empty-title-nadm">Aucune notification</h2>
              <p className="empty-text-nadm">
                Nous vous préviendrons dès qu'il y aura du nouveau.
                <br />
                Revenez plus tard pour vérifier vos notifications.
              </p>
            </div>
          )}
        </div>

        {/* Modal */}
        {Popup && selectedNotif && (
          <div
            className="admin-modal-overlay-nadm"
            onClick={() => setPopup(false)}
          >
            <div
              className="admin-modal-card-nadm"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                className="admin-modal-close-nadm"
                onClick={() => setPopup(false)}
              >
                <i className="bi bi-x-lg"></i>
              </button>

              {/* Icon */}
              <div className="admin-modal-icon-wrapper-nadm">
                <div className="admin-modal-icon-nadm">
                  <i className="bi bi-bell-fill"></i>
                </div>
              </div>

              {/* Content */}
              <div className="admin-modal-content-nadm">
                <h2 className="admin-modal-title-nadm">
                  {selectedNotif.Title}
                </h2>
                <p className="admin-modal-message-nadm">
                  {selectedNotif.Content}
                </p>

                <div className="admin-modal-meta-nadm">
                  <span className="admin-modal-date-nadm">
                    <i className="bi bi-clock"></i>
                    {selectedNotif.Date}
                  </span>
                </div>
              </div>

              {/* Actions */}
              <div className="admin-modal-actions-nadm">
                <button
                  className="admin-modal-btn-nadm primary-nadm"
                  onClick={() => setPopup(false)}
                >
                  <span>D'accord</span>
                  <i className="bi bi-check-lg"></i>
                </button>
                <button
                  className="admin-modal-btn-nadm secondary-nadm"
                  onClick={() => setPopup(false)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}